// ENTITY fr.gestionpial.pial.dto.CreneauDiffDTO generated by ic2 no-version-available at Thu Oct 01 15:16:30 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';
import { CreneauAffectation } from './CreneauAffectation';

export class CreneauDiffDTO {

  static readonly __ic2_fqn: string = 'fr.gestionpial.pial.dto.CreneauDiffDTO';

  toCreate: CreneauAffectation[] | null = [];
  toUpdate: CreneauAffectation[] | null = [];
  toDelete: number[] | null = [];

  constructor(init?:Partial<CreneauDiffDTO>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['fr.gestionpial.pial.dto.CreneauDiffDTO'] = CreneauDiffDTO;

fields['fr.gestionpial.pial.dto.CreneauDiffDTO']  = {
    toCreate: 'java.util.List<fr.gestionpial.pial.entities.CreneauAffectation>',
    toUpdate: 'java.util.List<fr.gestionpial.pial.entities.CreneauAffectation>',
    toDelete: 'java.util.List<java.lang.Integer>'
};
